import { z } from "zod"

import { entityIdSchema } from "./identifiers.js"

export const paymentRefundRequestV1Schema = z.object({
  correctionId: entityIdSchema,
  paymentAttemptId: entityIdSchema,
  amountMinor: z.number().int().positive(),
  reasonCode: z.enum([
    "customer_request",
    "duplicate",
    "service_issue",
    "other",
  ]),
  customerCommunicationRequested: z.boolean(),
  customerMessageCode: z.enum(["refund_requested", "refund_update"]).nullable(),
}).strict().superRefine((value, context) => {
  if (
    value.customerCommunicationRequested &&
    value.customerMessageCode === null
  ) context.addIssue({ code: "custom", message: "Message code required." })
})

export const collectionsHoldPlaceV1Schema = z.object({
  holdId: entityIdSchema,
  billingProfileId: entityIdSchema,
  reasonCode: z.enum(["payment_failure", "dispute", "manual_review"]),
  customerCommunicationRequested: z.boolean(),
  customerMessageCode: z.enum([
    "payment_method_action_required",
    "payment_under_review",
  ]).nullable(),
}).strict().superRefine((value, context) => {
  if (
    value.customerCommunicationRequested &&
    value.customerMessageCode === null
  ) context.addIssue({ code: "custom", message: "Message code required." })
})

export const collectionsHoldReleaseV1Schema = z.object({
  holdId: entityIdSchema,
  reasonCode: z.enum(["payment_resolved", "dispute_resolved", "manual_release"]),
}).strict()

export type PaymentRefundRequestV1 = z.infer<typeof paymentRefundRequestV1Schema>
export type CollectionsHoldPlaceV1 = z.infer<typeof collectionsHoldPlaceV1Schema>
export type CollectionsHoldReleaseV1 = z.infer<
  typeof collectionsHoldReleaseV1Schema
>
